import { Helmet } from "react-helmet";
import React from "react";
import { VROBJECTS } from "./constants";

export function directionToVector(origin, x_angle, y_angle, distance) {
    if (x_angle % 90 == 0) x_angle += 0.001;
    if (y_angle % 90 == 0) y_angle += 0.001;

    let theta = (x_angle * Math.PI / 180) + Math.PI / 2;
    let fi = y_angle * Math.PI / 180;
    let x = origin[0] - Math.sin(theta) * Math.sin(fi) * distance;
    let y = origin[1] - Math.cos(theta) * distance;
    let z = origin[2] - Math.sin(theta) * Math.cos(fi) * distance;
    let position = `${x} ${y} ${z}`;
    return position;
}

export function vectorToDirection(vector) {
    return vector;
}

export function cartesianToPolar(x, y, z) {
    y = y - 1.6; //origin
    let angle_x = Math.atan2(x, -z) * 180 / Math.PI;
    let length = Math.sqrt(x ** 2 + z ** 2);
    let angle_y = Math.atan2(y, length) * 180 / Math.PI;
    let distance = Math.sqrt(x ** 2 + y ** 2 + z ** 2);

    return {
        origin: [
            0.0,
            1.6,
            0.0
        ],
        x_angle: Math.round(angle_y),
        y_angle: -Math.round(angle_x),
        distance: distance
    };
}

export function mobileAndTabletCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export function iOS() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

export let arraysMatch = function (arr1, arr2) {

    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }

    return true;

};

export let validateEmail = function (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};


export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function deleteCookie(cname) {
    document.cookie = `${cname}=; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
}

export function removeElement(elementId) {
    // Removes an element from the document.
    let element = document.getElementById(elementId);
    if (element)
        element.parentNode.removeChild(element);
}

export function getAMPM(date) {
    //Get the am/pm format of a Date object
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
}

export const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
];

export function formatNumber(number) {
    let newNumber;
    number >= 10 ? newNumber = number : newNumber = "0" + number;
    return newNumber;
}

export function getYoutubeLinkID(url) {
    if (!url)
        return;
    let video_id = new URL(url).search.split("v=")[1];
    let ampersandPosition = video_id.indexOf("&");
    if (ampersandPosition != -1) {
        video_id = video_id.substring(0, ampersandPosition);
    }
    return video_id;
}

export function getTimezoneOffset() {
    function z(n) { return (n < 10 ? "0" : "") + n; }
    let offset = new Date().getTimezoneOffset();
    let sign = offset < 0 ? "+" : "-";
    offset = Math.abs(offset);
    offset = sign + z(offset / 60 | 0) + z(offset % 60);
    return parseInt(offset.slice(0, offset.length - 2));
}

export function diffMinutes(dt2, dt1) {

    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.round(diff);

}

export function insertParam(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    // kvp looks like ['key1=value1', 'key2=value2', ...]
    let kvp = document.location.search.substr(1).split("&");
    let i = 0;
    for (; i < kvp.length; i++) {
        if (kvp[i].startsWith(key + "=")) {
            let pair = kvp[i].split("=");
            pair[1] = value;
            kvp[i] = pair.join("=");
            break;
        }
    }
    if (i >= kvp.length) {
        kvp[kvp.length] = [key, value].join("=");
    }
    // can return this or...
    let params = kvp.join("&");
    // reload page with new params
    document.location.search = params;
}


// Calculates if the we are in the -15 to 65 minute range given the live session time
export function helpCalculateIfLiveSession(experience) {
    let liveSessionInRange = false;
    experience.live_sessions.forEach((liveSession) => {
        let sessionDate = new Date(liveSession.date);
        const minutesDiff = diffMinutes(sessionDate, new Date());
        if (minutesDiff < 15 && minutesDiff > -65) {
            liveSessionInRange = true;
        }
    });

    return liveSessionInRange;
}

// Get orientation depending on device
export function getOrientation() {
    if (iOS()) {
        if (window.orientation === 0 || window.orientation === 180) return "portrait";
    }
    else if (mobileAndTabletCheck()) {
        if (window.screen.orientation.type !== "landscape-primary") return "portrait";
    }

    return "landscape";
}


export function HelmetMetaData(experience) {
    if (experience.name !== undefined) {
        return (
            <Helmet>
                <title>{experience.name}</title>
                <meta property="title" content={experience.name} />
                <meta property="og:title" content={experience.name} />
                <meta property="og:image" content={experience.thumbnail} />
                <meta property="og:image:secure" content={experience.thumbnail} />
                <meta property="description" content={"Explore " + experience.name + "!"} />
                <meta property="og:description" content={"Explore " + experience.name + "!"} />
                <meta property="og:url" content={"https://app.immersotours.com/" + experience.slug} />
                <meta property="twitter:title" content={experience.name} />
                <meta property="twitter:image" content={experience.thumbnail} />
                <meta property="twitter:image:secure" content={experience.thumbnail} />
                <meta property="twitter:description" content={"Explore " + experience.name + "!"} />
                <meta property="twitter:card" content="summary_large_image" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
            </Helmet>
        );
    } else {
        return (<div></div>);
    }
}

export function sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}

export function closeHotSpotVR() {
    const waypointsGroup = document.getElementById(`group-${window.localStorage.getItem("locationID")}`)
    const hotspotsGroup = document.getElementById(`hotspots-${window.localStorage.getItem("locationID")}`)
    const hotspotCointainerVR = document.getElementById("hotspotCointainerVR")
    const closeButtonVR = document.getElementById("VRCloseButton")
    const infoButtonVR = document.getElementById("VRWatchInfo")


    const closeButtonBG = document.getElementById("VRCloseButtonBG")
    const closeButtonBorder = document.getElementById("VRCloseButtonBorder")
    const closeButtonText = document.getElementById("VRCloseButtonText")
    const closeButtonInfoBG = document.getElementById("VRCloseButtonInfoBG")
    const closeButtonInfoBorder = document.getElementById("VRCloseButtonInfoBorder")
    const closeButtonInfoText = document.getElementById("btnInfoButtonVR")
    const closeButtonImageText = document.getElementById("btnImageButtonVR")

    closeButtonText.setAttribute("scale", "0")
    closeButtonBG.setAttribute("scale", `0`)
    closeButtonBorder.setAttribute("scale", `0`)
    closeButtonInfoBG.setAttribute("scale", "0")
    closeButtonInfoBorder.setAttribute("scale", `0`)
    closeButtonInfoText.setAttribute("scale", `0`)
    closeButtonImageText.setAttribute("scale", `0`)

    //Show all the hotspots and waypoints
    waypointsGroup.setAttribute("scale", `1 1 1`)
    hotspotsGroup.setAttribute("scale", `1 1 1`)
    //Hide de Hotspot Container
    hotspotCointainerVR.setAttribute("height", "0")
    hotspotCointainerVR.setAttribute("width", "0")
    //Hide buttons for close the container and the info 
    closeButtonVR.setAttribute("geometry", "primitive: box; width: 0; height: 0; depth: 0")
    closeButtonVR.setAttribute("text", "value: ")
    infoButtonVR.setAttribute("geometry", "primitive: box; width: 0; height: 0; depth: 0")
    infoButtonVR.setAttribute("text", "value: ")
    //In case the user closes the container with the open info
    hotspotCointainerVR.setAttribute("opacity", "1")
    //Set the correct text to the hotspot
    hotspotCointainerVR?.getAttribute("text") && hotspotCointainerVR.setAttribute("text", `align: center; value: ${hotspotCointainerVR.getAttribute("text").value}; opacity: 0`)
    hotspotCointainerVR.setAttribute("color", "")
}

export function hideObjectsNoVRAR() {
    if (!VROBJECTS.TRIVIA) {
        const list = document.getElementsByClassName("trivias-container")
        for (let item of list) {
            //console.log(item);
            item.setAttribute("scale", "0 0 0")
        }
    }
    if (!VROBJECTS.HOTSPOT) {
        const list = document.getElementsByClassName("hotspot-container")
        for (let item of list) {
            //console.log(item);
            item.setAttribute("scale", "0 0 0")
        }
    }
    if (!VROBJECTS.VIDEOHOTSPOT) {
        const list = document.getElementsByClassName("videoHotSpot-container")
        for (let item of list) {
            //console.log(item);
            item.setAttribute("scale", "0 0 0")
        }
    }
    if (!VROBJECTS.WAYPOINT) {
        const list = document.getElementsByClassName("waypoint-container")
        for (let item of list) {
            item.setAttribute("scale", "0 0 0")
        }
    }
}

export function showObjectsNoVRAR() {
    if (!VROBJECTS.TRIVIA) {
        const list = document.getElementsByClassName("trivias-container")
        for (let item of list) {
            //console.log(item);
            item.removeAttribute("scale")
        }
    }
    if (!VROBJECTS.HOTSPOT) {
        const list = document.getElementsByClassName("hotspot-container")
        for (let item of list) {
            //console.log(item);
            item.removeAttribute("scale")
        }
    }
    if (!VROBJECTS.VIDEOHOTSPOT) {
        const list = document.getElementsByClassName("videoHotSpot-container")
        for (let item of list) {
            //console.log(item);
            item.removeAttribute("scale")
        }
    }

    if (!VROBJECTS.WAYPOINT) {
        const list = document.getElementsByClassName("waypoint-container")
        for (let item of list) {
            //console.log(item);
            item.removeAttribute("scale")
        }
    }
}